import isNumber from 'lodash/isNumber';

export const formatCurrency = value => {
  const val = Number(value);
  if (!isNumber(val)) {
    return 'N/A';
  }
  return `N${val.toLocaleString()}.00`;
};
